
import useAccountPages from "@/composables/useAccountPages";
import { Component, UserType } from "@/models/enums";
import userService from "@/services/user.service";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import { defineComponent, reactive, ref } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import { User } from "@/models/www/store/User";

export default defineComponent({
	components: {
		BaseInput,
		BaseButton,
	},
	setup() {
		const userStore = useUserStore();
		const { setComponent } = useAccountPages();
		const loading = ref<boolean>(false);

		const state = reactive({
			email: "",
		});

		const rules = {
			email: { required, email },
		};

		const v$ = useVuelidate(rules, state);

		const submit = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();

			if (isValid) {
				loading.value = true;
				userService
					.customerExist(state.email)
					.then(() => {
						setComponent(Component[Component.AccountLogin]);
						userStore.setUser({ email: state.email, type: UserType.Unknown } as User);
					})
					.catch(() => setComponent(Component[Component.AccountRegistration]))
					.finally(() => (loading.value = false));
			}
		};

		return { v$, submit, loading, state };
	},
});
